import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component"
import classNames from "classnames"
import instanceOfClassName from "@kaspernj/api-maker/build/instance-of-class-name"
import Link from "@kaspernj/api-maker/build/link"
import memo from "set-state-compare/build/memo"
import PropTypes from "prop-types"
import React from "react"
import Routes from "shared/routes"
/**
 * @typedef {object} ComponentsCheckInsLinkProps
 * @property {unknown} adminLayout
 * @property {unknown} checkIn
 * @property {unknown} children
 * @property {string} className
 * @property {unknown} userLayout
 */

/** @typedef {object} ComponentsCheckInsLinkState */

/**
 * @extends {ShapeComponent<ComponentsCheckInsLinkProps, ComponentsCheckInsLinkState>}
 */
class ComponentsCheckInsLink extends ShapeComponent {
  static defaultProps = {
    adminLayout: false,
    userLayout: false
  }

  static propTypes = {
    adminLayout: PropTypes.bool.isRequired,
    className: PropTypes.string,
    checkIn: instanceOfClassName("CheckIn").isRequired,
    userLayout: PropTypes.bool.isRequired
  }

  render() {
    const {adminLayout, children, className, checkIn, userLayout, ...restProps} = this.props
    const generatedClassName = classNames("components--check-ins--link", className)
    const to = this.to()

    if (to) {
      return (
        <Link className={generatedClassName} to={to} {...restProps}>
          {children || checkIn.name()}
        </Link>
      )
    }

    return (
      <span className={generatedClassName} {...restProps}>
        {children || checkIn.name()}
      </span>
    )
  }

  to() {
    const {adminLayout, checkIn} = this.p

    if (adminLayout) return Routes.adminCheckInPath(checkIn.id())
  }
}

export default memo(shapeComponent(ComponentsCheckInsLink))
